import { gql } from "@apollo/client";

export const GET_DOCUMENTO_PROFESIONAL = gql`
    query GetDocumentoProfesional($idProfesional: Int!) {
        documentoProfesionalAdjunto(idProfesional: $idProfesional) {
            idArchivo
            idTipoArchivoDocumento
            idProfesional
            fechaAlta
            titulo
            extension
            archivo
            contentType 
        }
    }
`;

